import React, { useState } from 'react'
import { Select, MenuItem, OutlinedInput, TextField, Typography, Box } from '@mui/material'
import MDBox from 'components/MDBox'
import MDModal from 'components/MDModal'
import MDButton from 'components/MDButton'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices } from 'hook/services'
import { useAgencyInfo } from 'context/agency'

const appsTypes = [
  { label: 'Assets', value: 'assets' },
  { label: 'Media Library', value: 'media' },
  { label: 'Onboard', value: 'onboard' },
  { label: 'Check List', value: 'checklist' },
  { label: 'Quiz', value: 'quiz' },
  { label: 'Change Log', value: 'change_log' },
  { label: 'Roadmap', value: 'roadmap' },
  { label: 'Knowledgebase', value: 'knowledgebase' },
  { label: 'Custom Value Form', value: 'custom_value_Form' },
  { label: 'White Board', value: 'whiteBoard' },
]

const assetTypes = [
  { label: 'Workflows', value: 'workflows' },
  { label: 'Custom Fields', value: 'custom_fields' },
  { label: 'Custom Values', value: 'custom_values' },
  { label: 'Pipelines', value: 'pipelines' },
  { label: 'Forms', value: 'forms' },
  { label: 'Surveys', value: 'surveys' },
  { label: 'Funnels', value: 'funnels' },
  { label: 'Calendars', value: 'calendars' },
  { label: 'Calendar Groups', value: 'calendar_groups' },
  { label: 'Objects', value: 'objects' },
  { label: 'Tags', value: 'tags' },
  { label: 'Trigger Links', value: 'trigger_links' },
  { label: 'Email Templates', value: 'email_templates' },
  { label: 'SMS Templates', value: 'sms_templates' },
  { label: 'Invoice Templates', value: 'invoice_templates' },
]

const AddProduct = ({ open, onClose, handleRefresh }) => {
  const AppService = useAppServices()
  const [processing, setProcessing] = useState(false)

  const [formData, setFormData] = useState({
    type: '',
    assetType: '',
    min_quantity: '',
    points: '',
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    const payload = {
        app_type: formData.type,
        asset_type: formData.type === 'assets' ? formData.assetType : null,
        min_quantity: Number(formData.min_quantity),
        points: Number(formData.points),
    }
console.log(payload)
// return 0
    const { response } = await AppService.CompetitionPoints.create({ payload })

    if (response) {
      setProcessing(false)
      onClose()
      handleRefresh()
    } else {
      setProcessing(false)
    }
  }

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    p: 4,
  }

  return (
    <MDModal open={open} onClose={onClose}>
      <MDBox component="form" onSubmit={handleSubmit} sx={modalStyle}>
        <MDTypography variant="h5" mb={2}>
          Competition Points
        </MDTypography>

        <MDBox mb={2}>
          <MDTypography variant="button" fontSize="14px" fontWeight="500">
            Type
          </MDTypography>
          <Select
            fullWidth
            name="type"
            value={formData.type}
            onChange={handleChange}
            input={<OutlinedInput />}
            sx={{ mt: 1 }}
          >
            {appsTypes.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                {type.label}
              </MenuItem>
            ))}
          </Select>
        </MDBox>

        {formData.type === 'assets' && (
          <MDBox mb={2}>
            <MDTypography variant="button" fontSize="14px" fontWeight="500">
              Asset Type
            </MDTypography>
            <Select
              fullWidth
              name="assetType"
              value={formData.assetType}
              onChange={handleChange}
              input={<OutlinedInput />}
              sx={{ mt: 1 }}
            >
              {assetTypes.map((type) => (
                <MenuItem key={type.value} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
          </MDBox>
        )}

        <MDBox mb={2}>
          <MDTypography variant="button" fontSize="14px" fontWeight="500">
            Minimum Quantity
          </MDTypography>
          <MDInput
            name="min_quantity"
            type="number"
            value={formData.min_quantity}
            onChange={handleChange}
            placeholder="Minimum Quantity"
            fullWidth
          />
        </MDBox>

        <MDBox mb={2}>
          <MDTypography variant="button" fontSize="14px" fontWeight="500">
            Points
          </MDTypography>
          <MDInput
            name="points"
            type="number"
            value={formData.points}
            onChange={handleChange}
            placeholder="Points"
            fullWidth
          />
        </MDBox>

        <MDBox display="flex" justifyContent="flex-end">
          <MDButton
            type="button"
            variant="gradient"
            color="primary"
            onClick={onClose}
            sx={{ mt: 2 }}
          >
            Close
          </MDButton>
          <MDButton
            type="submit"
            variant="gradient"
            color="info"
            loading={processing}
            disabled={processing}
            sx={{ mt: 2, ml: 1 }}
          >
            Add
          </MDButton>
        </MDBox>
      </MDBox>
    </MDModal>
  )
}

const CreateModal = ({ products, handleRefresh }) => {
  const [openAddProduct, setOpenAddProduct] = useState(false)

  return (
    <>
      <MDButton color="white" variant="contained" onClick={() => setOpenAddProduct(true)}>
        Create
      </MDButton>
      <AddProduct
        open={openAddProduct}
        onClose={() => setOpenAddProduct(false)}
        handleRefresh={handleRefresh}
      />
    </>
  )
}

export default CreateModal
